import api from '../../../services/api';
import { readItem, readPage } from '../../../utils/apiResult';

// ADAY PROFİLİ — SPEC F1 uçları (`v1/ats-candidates/{id}/...`; `{id}` = AtsCandidate.Id,
// sunucu kişiyi (LifecyclePersonId) kendisi çözer — notlar/etiketler/belgeler kişiye
// bağlıdır ki aynı kişinin bölünmüş aday satırları ortak görsün).
//   GET    {id}/profile                → aday + consent{} + tags[] + pools[] + canWrite + isPanelOnlyViewer
//   GET    {id}/applications           → kişinin TÜM başvuruları (kapsam süzgeçli)
//   GET    {id}/notes | POST {id}/notes { body } | PUT/DELETE {id}/notes/{noteId}
//   GET    {id}/tags  | PUT {id}/tags { tagIds: [] }                      (AT.Write)
//   GET    {id}/documents | POST {id}/documents | DELETE {id}/documents/{docId} (yazma AT.Write)
//   PUT    {id}/consent { consentVersion?, expiresAt, evidenceNote }         (AT.Write)
//   POST   {id}/anonymize                                                     (AT.Write; aktif başvuru → 409)
//
// OKUMALAR: api.js reject ETMEZ → `res.data.status` gerçek sinyal (readItem/readPage).
// YAZMALAR: hata interceptor'da toast'lanır (ev kuralı); burada yalnız başarı döner.

export const candidateRoot = (id) => `/v1/ats-candidates/${id}`;

// Belge türleri — sunucudaki beyaz listenin birebir aynısı (SPEC F1 AtsCandidateDocument).
export const CANDIDATE_DOCUMENT_TYPES = [
  'resume', 'certificate', 'diploma', 'portfolio', 'reference_letter', 'id_document', 'other',
];

export const NOTE_BODY_MAX = 4000;
export const DOCUMENT_NAME_MAX = 200;

const writeOk = (res) => res?.data?.status !== false;

const safeWrite = async (fn) => {
  try {
    const res = await fn();
    return writeOk(res) ? { ok: true, data: res?.data?.data ?? null } : { ok: false };
  } catch {
    return { ok: false };
  }
};

const readList = (res) => {
  const { ok, items } = readPage(res);
  return { ok, items };
};

export const getProfile = async (id) => readItem(await api.get(`${candidateRoot(id)}/profile`));

export const getCandidateApplications = async (id) =>
  readList(await api.get(`${candidateRoot(id)}/applications`));

export const getNotes = async (id) => readList(await api.get(`${candidateRoot(id)}/notes`));
export const createNote = (id, body) => safeWrite(() => api.post(`${candidateRoot(id)}/notes`, { body }));
export const updateNote = (id, noteId, body) =>
  safeWrite(() => api.put(`${candidateRoot(id)}/notes/${noteId}`, { body }));
export const deleteNote = (id, noteId) => safeWrite(() => api.delete(`${candidateRoot(id)}/notes/${noteId}`));

export const getTags = async (id) => readList(await api.get(`${candidateRoot(id)}/tags`));
export const setTags = (id, tagIds) => safeWrite(() => api.put(`${candidateRoot(id)}/tags`, { tagIds }));

export const getDocuments = async (id) => readList(await api.get(`${candidateRoot(id)}/documents`));
export const createDocument = (id, payload) =>
  safeWrite(() => api.post(`${candidateRoot(id)}/documents`, payload));
export const deleteDocument = (id, docId) =>
  safeWrite(() => api.delete(`${candidateRoot(id)}/documents/${docId}`));

// Rıza yenileme — AYRI uç: mevcut aday `Update`'i ConsentExpiresAt'i null'a ezme
// tuzağı taşıdığı için rıza ASLA aday formundan yazılmaz.
export const buildConsentPayload = (values) => {
  const version = values.consentVersion === '' || values.consentVersion == null
    ? null : Number(values.consentVersion);
  return {
    consentVersion: Number.isFinite(version) ? version : null,
    expiresAt: values.expiresAt,
    evidenceNote: (values.evidenceNote || '').trim(),
  };
};

export const renewConsent = (id, values) =>
  safeWrite(() => api.put(`${candidateRoot(id)}/consent`, buildConsentPayload(values)));

export const anonymizeCandidate = (id) => safeWrite(() => api.post(`${candidateRoot(id)}/anonymize`));
